export function asBoolean(value: string): boolean | null {
  switch (value.toLowerCase()) {
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return null;
  }
}

export function asNumber(value: string): number | null {
  const parsed = +value;
  return isNaN(parsed) ? null : parsed;
}
